import { createSelector } from 'reselect';

import { TAX_LINE_ITEMS_REDUCER_KEY } from './taxLineItemsTypes';

export const getTaxLineItemsStore = (state) => state[TAX_LINE_ITEMS_REDUCER_KEY];

// required default selectors
export const getResourcesById = (state) => getTaxLineItemsStore(state).resourcesById;
export const getLoadPending = (state) => getTaxLineItemsStore(state).loadPending;
export const getIsLoading = (state) => getTaxLineItemsStore(state).isLoading;
export const getError = (state) => getTaxLineItemsStore(state).error;
export const getLastSyncDate = (state) => getTaxLineItemsStore(state).lastSyncDate;

export const getTaxLineItemForId = (state, id) => getResourcesById(state).get(id);

export const getTaxLineItemsByTaxFormId = createSelector(getResourcesById, (taxLineItemsById) =>
  taxLineItemsById
    .toList()
    .groupBy((taxLineItem) => taxLineItem.formId)
    .sortBy((taxLineItem) => taxLineItem.displayOrder),
);
